import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import { useLanguage } from '../../context/LanugageContext'
import Lightbox from "yet-another-react-lightbox"
import { contentTranslations } from '../../translations/content'

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated',
    easing: 'ease-in-out-cubic',
    duration: 1300
});

const Content = ({ content }) => {
    const { lang } = useLanguage();
    const tr = contentTranslations[lang];

    const [bookingWidget, setBookingWidget] = useState();
    const [plakatOpen, setPlakatOpen] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://widgets.regiondo.net/booking/v1/booking-widget.min.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, []);

    useEffect(() => {
        setBookingWidget()
        setTimeout(() => {
            setBookingWidget(content.bookingWidget)
        }, 200);
    }, [content])

    return (
        <div>
            <div className={content.heroClass} />

            <div className="wrapper">
                <div className="title">
                    <h1 className={content.class}>{content.header}</h1>
                </div>

                <div className="flex animated" data-aos="fade-top">
                    <div className='content-container'>
                        <div className="description">
                            <h2>{content.title}</h2>
                            <span className="line" />
                            <p>
                                {content.firstP} <a href={content.link}>{content.linkP}</a>
                                {content.and && <>{content.and}<a href={content.secondLink}>{content.secondLinkP}</a></>}
                                {" "}{content.secondP}
                            </p>
                            <p>{content.thirdP}</p>
                            <p>{content.fourthP}</p>
                            <p>{content.fifthP}</p>
                        </div>

                        <div className="info">
                            <p>- <b>{tr.start}</b> {tr.from} <b>{tr.slano}</b> {tr.in} <b>{content.startTime}</b></p>
                            <p>- {tr.pickUpPoint} <b>{tr.hotel}</b> {tr.in} <b>{content.pickUpTime}</b></p>
                            <p>- <b>{tr.freeTime}</b> {tr.freeTimeLabel} {content.infoFirstP} <b>{content.infoFirstPBold}</b></p>
                            {content.infoSecondP && (
                                <p>- <b>{content.infoSecondPBold}</b> {content.infoSecondP} <b>{content.infoSecondPSecondBold}</b></p>
                            )}
                            {content.infoThirdP && (
                                <p>- {content.infoThirdP} <b>{content.infoThirdPBold}</b></p>
                            )}
                            <p>- <b>{tr.arrival}</b> {tr.in} <b>{tr.slano}</b> {tr.around} <b>{content.infoArrivalTimeP}</b></p>
                            <br />
                            <p><b>{tr.price}: {content.price} {tr.perAdult}</b></p>
                            <span>{tr.childrenFree} <b>{tr.childrenFreeAge}</b> {tr.childrenFreeEnd} <b>{tr.childrenFreeBold}</b></span>
                            <span>{tr.childrenDiscount} <b>{tr.childrenDiscountAge}</b> {tr.childrenDiscountEnd} <b>{tr.childrenDiscountBold}</b></span>
                            <br />
                            <p><b>{tr.included}: </b></p>
                            <span>
                                <b>{tr.drinks}</b> {tr.drinksDetail}
                                {content.infoLunch && (
                                    <>{content.infoLunch} <b>{content.infoLunchBold}</b> {content.infoLunchSecond}</>
                                )}
                            </span>
                            {content.infoVegeLunch && <span>{content.infoVegeLunch}</span>}
                            <br />
                            <p><b>{tr.reservations}</b></p>
                            <div className="contact">
                                <span>
                                    <i className="fas fa-phone-alt" />
                                    <i className="fab fa-whatsapp" />
                                    <i className="fab fa-viber" />
                                    +385 98 294 555
                                </span>
                                <span>
                                    <i className="fas fa-mail-bulk" />
                                    slanoboatexcursions@gmail.com
                                </span>
                            </div>
                            <br />
                            <span>{tr.weatherNote}</span>
                            <p></p>
                        </div>
                    </div>
                    <div className='img-container'>
                        {bookingWidget}
                        <img
                            src={content.plakat}
                            alt=""
                            onClick={() => setPlakatOpen(true)}
                            style={{ cursor: 'pointer' }}
                        />
                        <Lightbox
                            open={plakatOpen}
                            close={() => setPlakatOpen(false)}
                            slides={[{ src: content.plakat }]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Content;